import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import Divider from "@mui/material/Divider";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import PersonAddIcon from "@mui/icons-material/PersonAdd";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "25%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  border: "none",
};

export default function SaveUser({
  getUsers,
  userData,
  handleSnackbar,
  setSelectedUser,
  handleModelClose,
  handleCloseUserModal,
}) {
  const [roles, setRoles] = useState([]);
  const [userId, setUserId] = useState();

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    date_of_birth: "",
    role_id: "",
    contact_no: "",
    created_by: userId,
    updated_by: userId,
    email_id: "",
  });
  const [errors, setErrors] = useState({});
  const [originalData, setOriginalData] = useState(null); // Store original data for comparison

  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          console.log("response", response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_JHS_DEVELOPMENT + "/role/getrole",
        );

        const sortedRoles = response.data.sort((a, b) =>
          a.role_name.localeCompare(b.role_name),
        );

        setRoles(sortedRoles);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    if (userData) {
      setFormData(userData);
      setOriginalData(userData); // NEW LINE - Store original data when editing
      console.log("Pre-filling form with user data:", userData);
    }
  }, [userData]);

  // Function to check if form data has changed
  const hasFormChanged = () => {
    if (!originalData) return true; // If no original data, consider it as new (changed)

    // Compare relevant fields
    return (
      formData.first_name !== originalData.first_name ||
      formData.last_name !== originalData.last_name ||
      formData.gender !== originalData.gender ||
      formData.date_of_birth !== originalData.date_of_birth ||
      formData.role_id !== originalData.role_id ||
      formData.contact_no !== originalData.contact_no ||
      formData.email_id !== originalData.email_id
    );
  };

  //Arohi

  //Added validation code
  const validate = () => {
    let tempErrors = {};
    tempErrors.first_name = formData.first_name
      ? ""
      : "First Name is required.";
    tempErrors.last_name = formData.last_name ? "" : "Last Name is required.";
    tempErrors.gender = formData.gender ? "" : "Gender is required.";
    tempErrors.date_of_birth = formData.date_of_birth
      ? ""
      : "Date of Birth is required.";
    tempErrors.role_id = formData.role_id ? "" : "Role is required.";
    tempErrors.contact_no = formData.contact_no
      ? formData.contact_no.length < 10
        ? "Mobile No must be at least 10 digits."
        : ""
      : "Mobile No is required.";

    if (!formData.email_id) {
      tempErrors.email_id = "Email Id is required.";
    } else if (
      !formData.email_id.includes("@") ||
      !formData.email_id.includes(".") ||
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        formData.email_id,
      )
    ) {
      tempErrors.email_id = "Please enter a valid email id";
    } else {
      tempErrors.email_id = "";
    }
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update form data

    setFormData({
      ...formData,
      [name]: value,
    });

    // Validate each field on change
    let tempErrors = { ...errors };

    switch (name) {
      case "first_name":
        tempErrors.first_name = value ? "" : "First Name is required.";
        break;
      case "last_name":
        tempErrors.last_name = value ? "" : "Last Name is required.";
        break;
      case "gender":
        tempErrors.gender = value ? "" : "Gender is required.";
        break;
      case "date_of_birth":
        tempErrors.date_of_birth = value ? "" : "Date of Birth is required.";
        break;
      case "role_id":
        tempErrors.role_id = value ? "" : "Role is required.";
        break;
      case "contact_no":
        tempErrors.contact_no = value
          ? value.length > 10
            ? "Mobile No must be at least 10 digits."
            : ""
          : "Mobile No is required.";
        break;
      case "email_id":
        if (!value) {
          tempErrors.email_id = "Email Id is required.";
        } else if (
          !value.includes("@") ||
          !value.includes(".") ||
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
        ) {
          tempErrors.email_id = "Please enter a valid email id";
        } else {
          tempErrors.email_id = "";
        }
        break;
      default:
        break;
    }

    // Manually set created_by and updated_by to a specific userId (e.g., 1)
    const userid = userId; // Replace with actual user ID from your application context
    setFormData((prevData) => ({
      ...prevData,
      created_by: userid, // Set the created_by value
      updated_by: userid, // Set the updated_by value
    }));

    setErrors(tempErrors);
  };

  const saveUser = async () => {
    if (validate()) {
      try {
        if (userData) {
          // Check if any changes were made - NEW CODE
          if (!hasFormChanged()) {
            handleSnackbar("No changes detected.", "error");
            return;
          }

          await axios.post(
            process.env.REACT_APP_JHS_DEVELOPMENT + `/user/updateuser`,
            formData,
            { withCredentials: true },
          );
          // setSnackbarMessage('User updated successfully.');
          handleSnackbar("User updated successfully.", "success");
          if (handleCloseUserModal) {
            handleCloseUserModal();
          } else {
            handleModelClose();
          }
        } else {
          await axios.post(
            process.env.REACT_APP_JHS_DEVELOPMENT + "/user/createuser",
            formData,
            { withCredentials: true },
          );

          handleSnackbar("User created successfully.", "success");

          handleModelClose();
        }

        setSelectedUser(null);
        getUsers();
      } catch (error) {
        console.error("Error saving/updating user:", error);
        // Handling unauthorized access
        if (error.response && error.response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect to Sign-In page if unauthorized
          return; // Stop further execution
        }
        if (
          (error.response && error.response.data.error) ===
          "Failed to create user"
        ) {
          handleSnackbar(
            "Email ID already exists. Please use a different email.",
            "error",
          );
        }
        //Done by Simran . Added snackbar for dublicate email id

        if (
          (error.response && error.response.data.error) === "Validation error"
        ) {
          handleSnackbar(
            "Email ID already exists. Please use a different email.",
            "error",
          );
        }
      }
    }
  };

  const handleClose = () => {
    if (handleCloseUserModal) {
      handleCloseUserModal();
    } else {
      handleModelClose();
    }
  };

  return (
    <>
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          sx={{ color: "#0A64A2" }}
          id="modal-modal-title"
          variant="h6"
          component="h2"
        >
          {/* Arohi */}
          {/* Edit functionality */}
          <PersonAddIcon /> {userData ? "Edit User" : "Add User"}
        </Typography>
        <Divider style={{ background: "#0A64A2" }} />
        <Box
          component="form"
          sx={{
            paddingTop: "10px",
            alignItems: "center",
          }}
          noValidate
          autoComplete="off"
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: 1,
              width: "100%",
            }}
          >
            <TextField
              id="outlined-first-name"
              label={errors.first_name ? errors.first_name : "First Name"}
              fullWidth
              type="text"
              required
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
              size="small"
              error={!!errors.first_name}
              sx={{ mb: 1, pt: 0, pb: 0 }}
              inputProps={{
                maxLength: 50,
                onInput: (e) => {
                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                },
              }}
            />
            <TextField
              id="outlined-last-name"
              label={errors.last_name ? errors.last_name : "Last Name"}
              fullWidth
              required
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
              size="small"
              error={!!errors.last_name}
              sx={{ mb: 1, pt: 0, pb: 0 }}
              inputProps={{
                maxLength: 50,
                onInput: (e) => {
                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                },
              }}
            />
            <FormControl
              fullWidth
              sx={{ mb: 1, pt: 0, pb: 0 }}
              error={!!errors.gender}
              size="small"
            >
              <InputLabel id="select-gender-label" required>
                Gender
              </InputLabel>
              <Select
                labelId="select-gender-label"
                id="select-gender"
                value={formData.gender}
                onChange={handleInputChange}
                label={errors.gender ? errors.gender : "Gender"}
                name="gender"
              >
                <MenuItem value="M">Male</MenuItem>
                <MenuItem value="F">Female</MenuItem>
              </Select>
            </FormControl>

            <TextField
              sx={{
                "& input::-webkit-calendar-picker-indicator": {
                  cursor: "pointer",
                },
              }}
              size="small"
              required
              margin="dense"
              name="date_of_birth"
              label={
                errors.date_of_birth ? errors.date_of_birth : "Date of birth"
              }
              type="date"
              inputProps={{ max: today }}
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={formData.date_of_birth}
              onChange={handleInputChange}
              error={!!errors.date_of_birth}
            />

            <TextField
              size="small"
              fullWidth
              sx={{ pt: 0, pb: 0 }}
              select
              error={!!errors.role_id}
              labelId="select-role-label"
              id="select-role"
              value={formData.role_id}
              onChange={handleInputChange}
              label={errors.role_id ? errors.role_id : "Select Role"}
              name="role_id"
            >
              {roles
                .filter(
                  (role) =>
                    role.role_id !== 1 &&
                    role.role_name.toLowerCase() !== "student",
                ) // Exclude role_id = 1 and role_name = student
                .map((role) => (
                  <MenuItem key={role.role_id} value={role.role_id}>
                    {role.role_name}
                  </MenuItem>
                ))}
            </TextField>

            <TextField
              type="text" // Change type to 'text' to allow maxLength to work
              id="outlined-mobile-number"
              label={errors.contact_no ? errors.contact_no : "Contact number"}
              fullWidth
              required
              name="contact_no"
              value={formData.contact_no}
              onChange={(e) => {
                const inputValue = e.target.value;
                // Allow only numeric input and restrict to 10 digits
                if (/^\d*$/.test(inputValue)) {
                  handleInputChange({
                    target: {
                      name: "contact_no",
                      value: inputValue.slice(0, 10), // Allow only up to 10 digits
                    },
                  });
                }
              }}
              size="small"
              error={!!errors.contact_no}
              inputProps={{
                maxLength: 10, // Maximum of 10 characters
                inputMode: "numeric", // Ensures a numeric keyboard on mobile devices
                pattern: "[0-9]*", // Allow only numbers
              }}
              sx={{ pt: 0, pb: 0 }}
            />

            <TextField
              id="outlined-email-id"
              label={errors.email_id ? errors.email_id : "Email Id"}
              fullWidth
              required
              name="email_id"
              value={formData.email_id}
              onChange={handleInputChange}
              size="small"
              error={!!errors.email_id}
              sx={{ pt: 0, pb: 0 }}
            />
          </Box>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              className="save_update_btn"
              variant="contained"
              onClick={saveUser}
              sx={{ mt: 2 }}
            >
              {userData ? "Update" : "Save"}
            </Button>
          </div>
        </Box>
      </Box>
    </>
  );
}
